
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Resolver",
      function () {
        return require("private-next-pages/Resolver.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Resolver"])
      });
    }
  